import { render } from "./ServicesStatsSection.vue?vue&type=template&id=c8097f1c"
import script from "./ServicesStatsSection.vue?vue&type=script&lang=js"
export * from "./ServicesStatsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__